import { createSelector } from "@reduxjs/toolkit";

import { selectAllOrganizationRadioChannels } from "./organization.radio.slice";

export const selectAllUnarchivedRadioChannels = createSelector(
	[selectAllOrganizationRadioChannels],
	(orgRadioChannels) => {
		return orgRadioChannels.mapNotNull((c) => c.radioChannel).filter((c) => !c.isArchived);
	},
);
